import { NgClass } from '@angular/common';
import { Component, computed, input, output } from '@angular/core';
import { ButtonComponent } from '../button/button.component';
import { CloseComponent } from '../close/close.component';
import { Icon } from '../icons';
import { IconComponent } from '../icons/icon/icon.component';

export interface UIAlertAction {
  label: string;
  onClick: () => void;
  loading?: boolean;
  loadingLabel?: string;
}

export type UIAlertColor = 'gray' | 'error' | 'warning' | 'success' | 'brand' | 'secondary';

export type UIAlertType = 'hovering' | 'inline' | 'system';

@Component({
  selector: 'ui-alert',
  standalone: true,
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.scss',
  imports: [IconComponent, ButtonComponent, NgClass, CloseComponent],
})
export class AlertComponent {
  readonly type = input<UIAlertType>('inline');
  readonly color = input<UIAlertColor>();
  readonly icon = input<Icon>();
  readonly title = input<string>();
  readonly message = input<string>();
  readonly action = input<UIAlertAction>();
  readonly secondaryAction = input<UIAlertAction>();
  readonly hideCloseButton = input<boolean>(false);
  readonly isMobile = input<boolean>(false);

  readonly onClose = output<void>();

  readonly typeClass = computed(() => {
    return `ui-alert-type-${this.type()}`;
  });

  readonly colorClass = computed(() => {
    const color: UIAlertColor = this.color() || (this.type() === 'system' ? 'brand' : 'gray');
    return `ui-alert-color-${color}`;
  });

  readonly secondaryActionVariant = computed(() => {
    if (this.type() === 'system') {
      return 'quaternary';
    }

    return 'tertiary';
  });

  readonly actionVariant = computed(() => {
    if (this.type() === 'system') {
      return 'tertiary';
    }

    if (this.color() === 'secondary') {
      return 'secondary';
    }

    return 'primary';
  });

  readonly buttonSize = computed(() => {
    return this.isMobile() ? 'md' : 'sm';
  });

  readonly mobileClass = computed(() => {
    return this.isMobile() ? 'ui-alert-mobile' : '';
  });
}
